import React from "react";

export default function FeaturesBlock({ data }) {
  const items = data.items || [
    { icon: "🎓", title: "Feature 1", description: "Description here" },
    { icon: "🚀", title: "Feature 2", description: "Description here" },
  ];

  return (
    <div style={{ margin: "30px 0" }}>
      <h2 style={{ marginBottom: "20px" }}>{data.title || "Features"}</h2>

      <div style={{ display: "flex", gap: "20px" }}>
        {items.map((f, i) => (
          <div
            key={i}
            style={{
              padding: "20px",
              background: "#1D1D1D",
              borderRadius: "10px",
              width: "220px",
              color: "white",
            }}
          >
            <div style={{ fontSize: "40px" }}>{f.icon}</div>
            <h3>{f.title}</h3>
            <p style={{ opacity: 0.7 }}>{f.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
